import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText.js';
import { ScrambleTextPlugin } from 'gsap/ScrambleTextPlugin.js';

gsap.registerPlugin(SplitText);
gsap.registerPlugin(ScrambleTextPlugin)

export default {
    delimiters: ['{(', ')}'],
    props: {
        sentence: {
            type: [String],
            required: true
        },
        animateDialog: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {

        }
    },
    mounted() {
        this.splitText()
        this.animate();
    },
    methods: {
        splitText() {
            this.split = new SplitText(this.$refs.output, { type: 'chars, words', tag: 'div' });
        },
        animate() {
            const stagger = 0.02
            this.tl = gsap.timeline({ onComplete: () => {
                this.showContentAfterCta = true
                this.$emit('completed')
                // this.callback();
                this.tl.kill()
            }})
            if(this.animateDialog) {
                this.tl.set(this.split.chars, { opacity: 0 }, 0);
                this.tl.set(this.split.chars, { opacity: 1, backgroundColor: 'black', force3D: true, stagger }, 0);
                this.tl.to(this.split.chars, { clearProps: 'backgroundColor', force3D: true, stagger, duration: stagger/2 }, stagger);
                this.tl.to(this.split.chars.filter(item => item.innerText != ' '), { scrambleText: { text: '{original}', chars: "lowerCase" }, duration: .25, stagger}, stagger);
            }
            this.tl.add(() => { this.$el.classList.add('-show-cursor') })
            this.tl.add(() => {}, '+=1.5');
        },
        skip() {
            if(this.tl) {
                this.tl.progress(1);
            }
        }
    },
    watch: {
        sentence(newValue) {
            this.showContentAfterCta = false;

            this.$nextTick(() => {
                this.splitText()
                this.animate()
            });
        }
    },
    template: `
        <div>
            <span ref="output" v-html="sentence"></span>
        </div>
    `
}
